function ShowSpinnerWhileResolvingState($rootScope, $document, $compile) {
  let elem;

  $rootScope.$on('$stateChangeStart', (event, toState) => {
    if (toState.resolve) {
      elem = $compile('<og-spinner-overlay class="og-overlay-fixed" og-while="true"></og-spinner-overlay>')($rootScope);
      $document[0].body.appendChild(elem[0]);
    }
  });

  $rootScope.$on('$stateChangeSuccess', () => {
    elem.remove();
  });

  $rootScope.$on('$stateChangeError', () => {
    elem.remove();
  });
}

ShowSpinnerWhileResolvingState.$inject = ['$rootScope', '$document', '$compile'];

module.exports = ShowSpinnerWhileResolvingState;
